import { gql } from '@apollo/client'

export default gql(`
query($id: ID!) {
    getTeamById(id: $id) {
        id
        opId
        title
        customName
    }    
}`)
